import {getFirebaseConfig, getVapidKey} from '@aboutyou/config';
import {Log} from '@aboutyou/mlm';
import {initializeApp} from '../../../../../../node_modules/firebase/app';
import {
  getMessaging,
  getToken,
} from '../../../../../../node_modules/firebase/messaging';

export const getUserPermissionsAndFirebaseToken = async (): Promise<
  string | undefined
> => {
  let currentToken: string | undefined;
  try {
    const registration = await navigator.serviceWorker.getRegistration('/');
    const app = initializeApp(getFirebaseConfig());
    const messaging = getMessaging(app);

    currentToken = await getToken(messaging, {
      vapidKey: getVapidKey(),
      serviceWorkerRegistration: registration,
    });
  } catch (err) {
    Log.error(
      '@aboutyou/logic-components',
      `[firebase-getToken]: ${err.message}`,
      {error: err},
    );
    return undefined;
  }

  return currentToken;
};
